import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Inventory from "@/pages/Inventory";
import ItemMaster from "@/pages/ItemMaster";
import AssetRegister from "@/pages/AssetRegister";
import Consumption from "@/pages/Consumption";
import Transactions from "@/pages/Transactions";
import Alerts from "@/pages/Alerts";
import Users from "@/pages/Users";
import Assistant from "@/pages/Assistant";
import Requisitions from "@/pages/Requisitions";
import Masters from "@/pages/Masters";

function Protected({ children, roles }) {
  const { user } = useAuth();
  if (user === null) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (user === false) return <Navigate to="/login" replace />;
  if (roles && user.role !== "super_admin" && !roles.includes(user.role))
    return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function AppRoutes() {
  const { user } = useAuth();
  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to="/" replace /> : <Login />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/inventory" element={<Protected roles={["store_manager", "procurement_officer", "quality_officer", "center_staff", "field_staff"]}><Inventory /></Protected>} />
      <Route path="/items" element={<Protected roles={["store_manager", "procurement_officer"]}><ItemMaster /></Protected>} />
      <Route path="/assets" element={<Protected roles={["store_manager", "procurement_officer"]}><AssetRegister /></Protected>} />
      <Route path="/consumption" element={<Protected roles={["technician", "store_manager"]}><Consumption /></Protected>} />
      <Route path="/transactions" element={<Protected roles={["store_manager", "procurement_officer", "quality_officer"]}><Transactions /></Protected>} />
      <Route path="/alerts" element={<Protected><Alerts /></Protected>} />
      <Route path="/assistant" element={<Protected><Assistant /></Protected>} />
      <Route path="/users" element={<Protected roles={[]}><Users /></Protected>} />
      <Route path="/requisitions" element={<Protected roles={["technician", "center_staff", "field_staff", "store_manager", "procurement_officer", "quality_officer"]}><Requisitions /></Protected>} />
      <Route path="/masters" element={<Protected roles={[]}><Masters /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <AppRoutes />
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}
